<script setup lang="ts">
  import {
    CalendarDaysIcon,
    ClipboardDocumentCheckIcon,
    HomeIcon,
    MagnifyingGlassIcon,
  } from '@heroicons/vue/24/outline';
  import { useRoute } from 'vue-router';
  import { useAuthStore } from '@/stores/auth.ts';

  const auth = useAuthStore();
  const route = useRoute();
</script>

<template>
  <div
    class="md:absolute md:max-w-lg md:m-auto btm-nav overflow-hidden drop-shadow-[0_0px_5px_rgba(0,0,0,0.1)]">
    <RouterLink
      v-if="auth.isUser && auth.isOrigin"
      :to="{ name: 'Home' }"
      :class="{ active: route.name === 'Home' }">
      <HomeIcon class="h-5 w-5" />
      <span class="btm-nav-label text-xs">홈</span>
    </RouterLink>

    <RouterLink
      v-if="auth.isUser && auth.isOrigin"
      :to="{ name: 'AttendanceMonth' }"
      :class="{ active: route.name?.toString().startsWith('Attendance') }">
      <CalendarDaysIcon class="h-5 w-5" />
      <span class="btm-nav-label text-xs">근태현황</span>
    </RouterLink>

    <RouterLink
      v-if="auth.isUser && (auth.isOrigin || auth.isManager)"
      :to="{ name: 'Approval' }"
      :class="{ active: route.name?.toString().startsWith('Approval') }">
      <ClipboardDocumentCheckIcon class="h-5 w-5" />
      <span class="btm-nav-label text-xs">결재함</span>
    </RouterLink>

    <RouterLink
      v-if="auth.isUser"
      :to="{ name: 'Search' }"
      :class="{ active: route.name?.toString().startsWith('Search') }">
      <MagnifyingGlassIcon class="h-5 w-5" />
      <span class="btm-nav-label text-xs">조회</span>
    </RouterLink>

    <!-- <RouterLink
      :to="{ name: 'About' }"
      :class="{ active: route.name === 'About' }">
      <ClockIcon class="h-5 w-5" />
      <span class="btm-nav-label text-xs">조회</span>
    </RouterLink> -->
  </div>
</template>
